const categoriesState = {
  list: {},
}

export default categoriesState
